import { FC, useEffect, useState } from "react";
import { FooterProps } from "./footer.types";
import Footer1 from "./skins/footer-1/footer-1";
import Footer3 from "./skins/footer-3/footer-3";
import {
  TemplateType,
  WidgetCaller,
  getAddonFromStoreAddons,
  AddonTypeId,
} from "@commons-monorepo/index";
import { FooterContext } from "./footer.context";

const Footer: FC<FooterProps> = (props) => {
  const { theme, data, t } = props;
  const { Provider } = FooterContext;
  const [storeVerifiedFrom, setStoreVerifiedFrom] = useState<string>();

  const providerValue = {
    theme,
    data,
  };

  const checkIfStoreIsVerified = async () => {
    const verifiedAddon = getAddonFromStoreAddons<{
      status: "completed" | "rejected";
    }>(data.userAddons, AddonTypeId.StoreVerification);
    if (verifiedAddon?.body?.status === "completed")
      setStoreVerifiedFrom(verifiedAddon.inits_at);
  };

  useEffect(() => {
    if (!props.data.storeMetadata) return;
    if (props.caller !== WidgetCaller.Customization) checkIfStoreIsVerified();
  }, []);

  return (
    <Provider value={providerValue}>
      {theme.template.FOOTER === TemplateType.FOOTER_1 && (
        <Footer1
          storeVerifiedFrom={storeVerifiedFrom}
          variant={TemplateType.FOOTER_1}
          t={t}
        />
      )}
      {theme.template.FOOTER === TemplateType.FOOTER_2 && (
        <Footer1
          storeVerifiedFrom={storeVerifiedFrom}
          variant={TemplateType.FOOTER_2}
          t={t}
        />
      )}
      {theme.template.FOOTER === TemplateType.FOOTER_3 && (
        <Footer3 storeVerifiedFrom={storeVerifiedFrom} t={t} />
      )}
    </Provider>
  );
};

export default Footer;
